import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';


const EndSessionConfirmation = ({ show, sessionData, sessionDuration, onCancel, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-warning/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertCircle" size={20} className="text-warning" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              End Session?
            </h3>
            <p className="text-sm text-muted-foreground">
              Are you sure you want to end this session? You'll be redirected to provide feedback and schedule follow-up if needed.
            </p>
          </div>
        </div>
        <div className="bg-muted rounded-lg p-4 mb-4">
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-muted-foreground">Session duration</span>
            <span className="font-medium text-foreground">
              {Math.floor(sessionDuration / 60)}m {sessionDuration % 60}s
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">With</span>
            <span className="font-medium text-foreground">
              {sessionData?.participantName}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            fullWidth
            onClick={onCancel}
          >
            Continue Session
          </Button>
          <Button
            variant="destructive"
            fullWidth
            onClick={onConfirm}
          >
            End Session
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EndSessionConfirmation;